import { PropsWithChildren } from 'preact/compat';

type ImgProps = PropsWithChildren<{
  className?: string;
}> &
  React.HTMLAttributes<HTMLDivElement>;

export default function Img({ children, className, ...rest }: ImgProps) {
  return (
    <div
      className={`GiftBox-Offer-Image justify-center w-14 h-14 bg-gray-50 rounded-[10px] flex-none relative flex items-center [&>img]:overflow-hidden [&>img]:max-h-full [&>img]:max-w-full [&>img]:rounded-lg [&>svg]:w-11 [&>svg]:h-11 ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
}
